<script lang="ts">
  import type { OrderOption } from "../../models/order-options.interface";
  import OptionRow from "./OptionRow.svelte";
  import { fileStore } from "../../services/select-files";
  import { orderStore } from "../../services/order-options-service";

  const id = "files";
  export let option: OrderOption;

  // Default stations
  orderStore.setOrderValue(
    id,
    [...$fileStore.selectedFiles].map((file) => {
      return {
        id: file.id,
        value: file.id,
        selected: true
      };
    })
  );
</script>

<OptionRow
  {id}
  label="File Options"
  tooltip="Additional options related to the file format and content."
>
  <!-- 
    This section will display the configurable options (like checkboxes) 
    once a 'values' array is added to the 'files' option in the metadata.
    For now, it shows a placeholder.
  -->
  {#if $orderStore.options[id]}
    {#each $orderStore.values[id] as option}
      <div>{option.value}</div>
    {/each}
  {:else}
    <div class="p-3 bg-light rounded text-center text-muted small">
      No file options are available to configure for this dataset.
    </div>
  {/if}
</OptionRow>
